import exportCompoent from "@/components/export/ExportComponentDT.vue";
const pages = {
  components: {
    exportCompoent,
  },
  data() {
    return {
      isShowDialog_dc: false,
      diaWidth_dc: "60%",
      dialogTitle_dc: "导出数据",
      dialogForm_dc: {
        pageStart: 1,
        pageTotal: "",
        fileName: "", //
        apiName: "", //当前数据列表的文件名
        EpType: "bdd", //dd==等待下载完成,bdd==不等待完成
        apiType: "POST", //导出当前列表的请求方式
        isJson: 1, //导出当前列表的请求头是否json 1= 是 0= 否
      },
      myTableHeard: [],
      EPtableHeard: [], //为了拖动弹窗的列表不影响列表排序
      EPAllCheck: false,
    };
  },
  created() {},
  watch: {
    isShowDialog_dc(a, b) {
      if (a) {
        let arrs = [];
        this.myTableHeard.forEach((item) => {
          if (item.isShow) {
            arrs.push(item);
          }
        });

        this.EPtableHeard = arrs;
        let flag = true;
        this.EPtableHeard.forEach((item) => {
          if (item.isShow == false) {
            flag = false;
          }
        });
        this.EPAllCheck = flag; //判断是否有全选
      }
    },
  },
  methods: {
    // 关闭弹窗
    handleCloseDia_dc(e) {
      this.isShowDialog_dc = false;
    },
    // 点击某一项(表格设置)
    checktabEP(idx, e, arrs) {
      let that = this;
      arrs[idx].isShow = e;
      let selectLength = 0;
      for (var i = 0; i < arrs.length; i++) {
        if (arrs[i].isShow) {
          selectLength++;
        }
      }
      if (selectLength == arrs.length) {
        that.EPAllCheck = true;
      } else {
        that.EPAllCheck = false;
      }
      this.EPtableHeard = JSON.parse(JSON.stringify(arrs || []));
    },
    //全选(表格设置)
    checkAllEP(e, arrs) {
      let that = this;
      that.EPAllCheck = e;
      for (var j = 0; j < arrs.length; j++) {
        arrs[j].isShow = e;
      }
      this.EPtableHeard = JSON.parse(JSON.stringify(arrs || []));
    },
    // 拖拽过后 更新数组
    onAfterEnter(arrs) {
      this.EPtableHeard = JSON.parse(JSON.stringify(arrs || []));
    },

    // 确定按钮
    diaConfirmBtn_dc() {
      if (!this.dialogForm_dc.fileName) {
        this.$message.error("请填写文件名");
        return false;
      }
      let that = this;
      let conditionReqs = [];
      let F_config = this.$refs.queryForm.F_config || this.queryCondditionDatas;
      F_config.forEach((element) => {
        let {
          textBoxType,
          conditonKey,
          dropdownSubmitField,
          conditonVal,
          timeType,
          timeChilds,
          startTime_a,
          endTime_a,
        } = element;
        switch (textBoxType) {
          case "input":
            conditionReqs.push({
              conditonKey,
              conditonVal,
            });
            break;
          case "select":
            conditionReqs.push({
              conditonKey: dropdownSubmitField || conditonKey,
              conditonVal,
            });
            break;
          case "dept_tree":
          case "select_more":
          case "dept_tree_strict":
            conditionReqs.push({
              conditonKey,
              conditonVal,
            });
            break;
          case "datetime":
            let curs = timeChilds[timeType];
            curs &&
              curs.children.forEach((element, index) => {
                conditionReqs.push({
                  conditonKey: element.conditonKey,
                  conditonVal:
                    index == 1
                      ? endTime_a
                        ? `${endTime_a} 23:59:59`
                        : ""
                      : startTime_a
                      ? `${startTime_a} 00:00:00`
                      : "",
                });
              });
            break;
          case "date":
            let curs2 = timeChilds[timeType];
            curs2 &&
              curs2.children.forEach((element, index) => {
                conditionReqs.push({
                  conditonKey: element.conditonKey,
                  conditonVal:
                    index == 1
                      ? endTime_a
                        ? `${endTime_a}`
                        : ""
                      : startTime_a
                      ? `${startTime_a}`
                      : "",
                });
              });
            break;
          default:
            break;
        }
      });
      let params = {
        conditionReqs,
        pageStart: this.pageStart,
        pageTotal: this.pageTotal,
        number: this.reportFiledsNumber,
      };

      let hArrs = [];
      this.EPtableHeard.forEach((element) => {
        if (element.isShow) {
          if (element.child && element.child.length) {
            element.child.forEach((element1) => {
              if (element1.isShow) {
                hArrs.push({
                  fieldKey: element1.field,
                  titleValKey: element1.name,
                });
              }
            });
          } else {
            hArrs.push({
              fieldKey: element.field,
              titleValKey: element.name,
            });
          }
        }
      });

      let d = {
        fileName: this.dialogForm_dc.fileName || "fileName",
        headsTitles: JSON.stringify(hArrs), //表头 数组
        pageCount: this.dialogForm_dc.pageTotal || 20000, //数据总条数 最多两万
        post: this.dialogForm_dc.apiType || "GET",
        selectDto: JSON.stringify(params), //列表查询条件
        sheetName: this.dialogForm_dc.fileName || "sheetName",
        url: this.$COMMON.baseURL + (this.dialogForm_dc.apiName || '/v1/common/query/runPageReport'),
        isJson: this.dialogForm_dc.isJson || 0, //是否json 1= 是 0= 否
      };

      if (this.dialogForm_dc.EpType === "dd") {
        // 等待导出完成
        // 生成导出文件流,前端转换下载
        this.$API.exportExcelByUrl(d).then((res) => {
          let data = res.data;
          // 获取响应的文件流数据
          const blob = new Blob([data], { type: "application/vnd.ms-excel" });
          let url = URL.createObjectURL(blob);
          let link = document.createElement("a");
          link.href = url;
          link.download = (this.dialogForm_dc.fileName || "导出文件") + ".xlsx"; // 设置下载文件名
          document.body.appendChild(link);
          link.click();
          URL.revokeObjectURL(url); // 撤销URL对象

          setTimeout(() => {
            that.isShowDialog_dc = false;
          }, 1000);
        });
      } else {
        // 导出(生成历史记录),只返回提示
        this.$API.exportExcelToRecord(d).then((res) => {
          this.$message.success("数据处理中,请到右上角导出记录中查询结果");
          setTimeout(() => {
            that.isShowDialog_dc = false;
          }, 1000);
        });
      }

      // 导出,返回下载链接
      // this.$API.exportExcelToUrl(d).then(res => {
      //     let data = res.data
      //     // 获取响应的文件流数据

      //     let url = data.result.url;

      //     // 创建一个链接并设置其属性
      //     const link = document.createElement('a');
      //     link.href = url;
      //     link.setAttribute('download', this.dialogForm_dc.fileName);

      //     // 在DOM中添加链接并自动点击以执行下载
      //     document.body.appendChild(link);
      //     link.click();

      //     // 下载完成后，清除链接
      //     document.body.removeChild(link);

      // })
    },
  },
};

export default pages;
